import { useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { ListContainer, ListContent } from '~/components/PageLayout';
import { Layout } from './components';

export const DataSourceAuditLogs = () => {
  const params = useParams<{ dataSourceId: string }>();
  const dataSourceId = parseInt(params.dataSourceId ?? '');

  return (
    <Layout noPadding>
      <ListContainer>
        <ListContent>
          <AuditLogList recordTypes={['DataSource']} dataSourceId={dataSourceId} fullHeight />
        </ListContent>
      </ListContainer>
    </Layout>
  );
};
